import React, { createContext } from 'react'

interface FieldsetContext {
  isDisabled: boolean
  isMandatory: (name: string) => boolean
}

const isFirstPassenger = (name: string): boolean => /^[^.]+\.0$/.test(name)

export const FieldsetContext = createContext<FieldsetContext>({
  isDisabled: false,
  isMandatory: () => true,
})

interface Props {
  children: React.ReactNode
  value: { isDisabled: boolean; isMandatory: boolean }
  className?: string
}

export const FieldsetProvider = ({ children, className, value }: Props) => (
  <FieldsetContext.Provider
    value={{ isDisabled: value.isDisabled, isMandatory: name => value.isMandatory || isFirstPassenger(name) }}
  >
    <fieldset className={className} disabled={value.isDisabled}>
      {children}
    </fieldset>
  </FieldsetContext.Provider>
)
